import React from 'react'
import B2BAudiencePenetrationFor2026 from '../components/B2BAudiencePenetrationFor2026'

export default function TheNewRulesOfB2BAudiencePenetrationFor2026() {
  return (
    <div>
      <B2BAudiencePenetrationFor2026/>
    </div>
  )
}
